var _rect, _path, _rect2, _rect3, _rect4, _path2, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 152,
    viewBox: "0 0 32 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#146EB4",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6005 9.94L12.8205 12.136V13.99L15.9165 11.92V22H17.7885V9.94H16.6005Z",
    fill: "#146EB4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#146EB4",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 31,
    width: 2,
    height: 89,
    fill: "#146EB4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 121,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#146EB4",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.861 140.254L17.237 137.986C19.055 136.258 19.955 135.142 19.955 133.414C19.955 131.2 18.317 129.688 15.923 129.688C13.511 129.688 11.855 131.182 11.765 133.54L13.529 133.9C13.619 132.226 14.501 131.362 15.905 131.362C17.201 131.362 18.101 132.208 18.101 133.45C18.101 134.89 17.147 135.736 16.085 136.726L11.909 140.758V142H20.063V140.254H14.861Z",
    fill: "#146EB4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 121,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#146EB4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseInventoryIcon);
export default __webpack_public_path__ + "static/media/warehouse-inventory-icon.4e530be6476ef1755d95e6d4a8bdfddf.svg";
export { ForwardRef as ReactComponent };